export default __webpack_public_path__ + "static/media/share_code.fd1425ea.png";